import Radio from 'components/Globals/Base/Radio';
import type { EventData } from 'services/Gtm/entities';
import * as S from './RadioGroupStyles';

interface RadioOptions {
  label: string;
  value: string;
}

export interface RadioGroupProps {
  label: string;
  options: RadioOptions[];
  ariaLabelledBy: string;
  name: string;
  onOptionChange: (value: string) => void;
  selectedOption: string;
  hasDisclaimer?: boolean;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  dataCy?: string;
  trackingData?: EventData;
}
export const RadioGroup = ({
  label,
  options,
  ariaLabelledBy,
  name,
  onOptionChange,
  selectedOption,
  hasDisclaimer,
  className,
  required,
  disabled,
  trackingData,
  dataCy,
}: RadioGroupProps) => {
  const handleOptionChange = (value: string) => {
    onOptionChange(value);
  };

  return (
    <S.RadioGroupWrapper
      role='radiogroup'
      aria-labelledby={ariaLabelledBy}
      className={className}
    >
      {label && (
        <S.Label id={ariaLabelledBy}>
          {label} {required && <span>*</span>}
          {hasDisclaimer && <span className='disclaimer'>*</span>}
        </S.Label>
      )}
      <S.RadioOptions>
        {options.map((option) => (
          <Radio
            key={option.value}
            name={name}
            value={option.value}
            checked={option.value === selectedOption}
            onChange={handleOptionChange}
            disabled={disabled}
            trackingData={trackingData}
            dataCy={dataCy}
          >
            {option.label}
          </Radio>
        ))}
      </S.RadioOptions>
    </S.RadioGroupWrapper>
  );
};
